export const DEFAULT_EXPERIENCE_INFO = 'Weniger ist mehr!<br/>Gib hier die <b>Minimalanforderungen</b> an. Dir werden in den Matchings auch Personen angezeigt, die deutlich mehr Erfahrung haben.';
